import { motion } from "framer-motion";
import { BadgeCheck, GraduationCap, Hospital } from "lucide-react";
import { CLINIC } from "@/data/content";

const DoctorPortrait = ({ parallaxY }) => {
  const Wrapper = parallaxY ? motion.div : "div";
  const wrapperProps = parallaxY ? { style: { y: parallaxY } } : {};
  return (
    <Wrapper {...wrapperProps} className="relative" data-testid="doctor-portrait">
      <div className="absolute -inset-6 rounded-[2.5rem] bg-gradient-to-br from-emerald-900/10 via-transparent to-amber-500/10 blur-2xl" />
      <div className="relative rounded-[2rem] border border-amber-600/30 bg-white p-3 shadow-[0_32px_80px_-24px_rgba(6,78,59,0.35)]">
        <div className="relative overflow-hidden rounded-[1.6rem] aspect-[4/5]">
          <img
            src={CLINIC.photo}
            alt="Dr. Ankur Lal — STD & Sexual Health Specialist, Dermatologist, Delhi"
            className="w-full h-full object-cover object-top"
            data-testid="doctor-photo"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-slate-950/55 via-transparent to-transparent" />
          <div className="absolute bottom-0 inset-x-0 p-5">
            <p className="font-serif text-2xl font-semibold text-white">Dr. Ankur Lal</p>
            <p className="text-[11px] tracking-[0.18em] uppercase text-emerald-200/90 font-semibold mt-1">
              {CLINIC.title}
            </p>
          </div>
        </div>
      </div>
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.9, duration: 0.7 }}
        className="absolute -left-3 sm:-left-6 top-8 bg-white/95 backdrop-blur border border-slate-900/10 rounded-2xl px-4 py-3 shadow-xl flex items-center gap-3"
      >
        <span className="w-9 h-9 rounded-full bg-amber-100 flex items-center justify-center shrink-0">
          <BadgeCheck className="w-5 h-5 text-amber-700" />
        </span>
        <div>
          <p className="text-xs font-bold text-slate-900 leading-tight">Gold Medalist</p>
          <p className="text-[11px] text-slate-500 leading-tight">MD Dermatology</p>
        </div>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: -16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1.05, duration: 0.7 }}
        className="absolute -right-3 sm:-right-6 top-8 bg-slate-950/95 backdrop-blur border border-white/10 rounded-2xl px-4 py-3 shadow-xl flex items-center gap-3"
      >
        <span className="w-9 h-9 rounded-full bg-emerald-900 flex items-center justify-center shrink-0">
          <Hospital className="w-5 h-5 text-emerald-200" />
        </span>
        <div>
          <p className="text-xs font-bold text-white leading-tight">Ex-STD Specialist</p>
          <p className="text-[11px] text-slate-400 leading-tight">AIIMS New Delhi</p>
        </div>
      </motion.div>
      <div className="absolute -top-8 -right-8 w-40 h-40 rounded-full bg-emerald-800/15 blur-3xl animate-float-slow pointer-events-none" />
      <div className="absolute -bottom-10 -left-10 w-48 h-48 rounded-full bg-amber-500/15 blur-3xl animate-float-slow pointer-events-none" style={{ animationDelay: "2.2s" }} />
    </Wrapper>
  );
};

export const CredentialList = ({ dark = false }) => {
  const items = [
    { icon: BadgeCheck, text: "Gold Medalist — MD Dermatology" },
    { icon: Hospital, text: "Ex-STD Specialist & Former Senior Resident — AIIMS New Delhi" },
    { icon: GraduationCap, text: "MBBS — King George's Medical University, Lucknow" },
    { icon: GraduationCap, text: "MD Dermatology — VMMC & Safdarjung Hospital, New Delhi" },
  ];
  return (
    <ul className="space-y-4" data-testid="credential-list">
      {items.map((c, i) => (
        <li key={i} className="flex items-start gap-3.5">
          <span
            className={`mt-0.5 w-9 h-9 rounded-full flex items-center justify-center shrink-0 ${
              dark ? "bg-emerald-900/60 text-amber-300" : "bg-emerald-50 text-emerald-900 border border-emerald-900/10"
            }`}
          >
            <c.icon className="w-4.5 h-4.5 w-[18px] h-[18px]" />
          </span>
          <span className={`text-sm sm:text-[15px] leading-relaxed ${dark ? "text-slate-200" : "text-slate-700"}`}>
            {c.text}
          </span>
        </li>
      ))}
    </ul>
  );
};

export default DoctorPortrait;
